import React from 'react';
import PropTypes, { bool } from 'prop-types';
import pathfinder from '@fiverr-private/pathfinder';
import * as Links from '../../../components/Links';

export const TeamDashboardLink = ({ teamOwnerUsername, onClick, isUppercase }) => {
    const path = pathfinder('team_member_dashboard_page', {
        team_slug: teamOwnerUsername,
    });

    return <Links.TeamMemberDashboardLink href={path} onClick={onClick} isUppercase={isUppercase} />;
};

TeamDashboardLink.propTypes = {
    teamOwnerUsername: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    isUppercase: bool,
};

export const TeamDashboardInviteLink = ({ teamOwnerUsername, onClick }) => {
    const path = pathfinder('team_member_dashboard_page', {
        team_slug: teamOwnerUsername,
    });

    return <Links.InviteTeamMembersDashboardLink onClick={onClick} href={`${path}?invite=true`} />;
};

TeamDashboardInviteLink.propTypes = {
    teamOwnerUsername: PropTypes.string.isRequired,
    onClick: PropTypes.func,
};

export const AccountDashboardLink = ({ sellerUsername, onClick }) => {
    const path = pathfinder('user_seller_dashboard_index', {
        user_id: sellerUsername,
    });

    return <Links.TeamMemberAccountDashboardLink href={path} onClick={onClick} />;
};

AccountDashboardLink.propTypes = {
    sellerUsername: PropTypes.string.isRequired,
    onClick: PropTypes.func,
};

export const InviteTeamMembersLink = ({ onClick }) => <Links.InviteTeamMembersDashboardLink onClick={onClick} />;

InviteTeamMembersLink.propTypes = {
    onClick: PropTypes.func,
};
